import { useState, useEffect } from 'react'

import type { WithMaintenanceProps } from './type'

import { MaintenanceScreen } from '@/components/features/maintenance/MaintenanceScreen'
import { appEmitter, APP_EVENT_NAMES } from '@/utils/appEmitter'

export const MaintenanceDetection = ({ children }: WithMaintenanceProps) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)

  useEffect(() => {
    const listener = (value: boolean) => {
      setIsMaintenanceMode(value)
    }
    appEmitter.on(APP_EVENT_NAMES.CHANGE_MENTENANCE_MODE, listener)
    return () => {
      appEmitter.off(APP_EVENT_NAMES.CHANGE_MENTENANCE_MODE, listener)
    }
  }, [])

  if (isMaintenanceMode) {
    return <MaintenanceScreen />
  } else {
    return <>{children}</>
  }
}
